// extracted by mini-css-extract-plugin
var _1 = "Dropdown_dropdownIndicator__5LEj1";
export { _1 as "dropdownIndicator" }
